import { useState } from "react";
import { useTranslation } from "react-i18next";
import { jod } from "@astroplanet/shared";
import { useToast } from "../../context/ToastContext";
import { useShift, keys } from "../../hooks/queries";
import { api } from "../../lib/api";
import { useQueryClient } from "@tanstack/react-query";
import { ActiveBandsTable } from "./ActiveBandsTable";
import { CheckInForm } from "./CheckInForm";

/** The cashier workspace: open a shift, check families in, watch the wristbands tick down. */
export function CashierGrid() {
  const shift = useShift();
  const open = !!shift.data?.shift;
  return (
    <div className="space-y-5">
      {!shift.isLoading && !open && <OpenShiftCard />}
      <CheckInForm shiftOpen={open} />
      <ActiveBandsTable />
    </div>
  );
}

function OpenShiftCard() {
  const { t } = useTranslation();
  const { toast, toastError } = useToast();
  const qc = useQueryClient();
  const [float, setFloat] = useState("50.000");
  const [busy, setBusy] = useState(false);

  async function open() {
    setBusy(true);
    try {
      await api.post("/shifts/open", { openingFloat: jod(Number(float)) });
      toast(t("shift.opened"), "success");
      await qc.invalidateQueries({ queryKey: keys.shift });
    } catch (e) {
      toastError(e);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card flex flex-wrap items-end gap-3 border-amber-200 bg-amber-50/50 p-4">
      <div className="min-w-56 flex-1">
        <h2 className="text-sm font-black text-amber-900">🔓 {t("shift.openTitle")}</h2>
        <p className="text-xs text-amber-800">{t("shift.openHint")}</p>
      </div>
      <div>
        <label className="label" htmlFor="float">{t("shift.openingFloat")}</label>
        <input id="float" className="field num w-32 font-mono" inputMode="decimal" value={float} onChange={(e) => setFloat(e.target.value)} />
      </div>
      <button type="button" className="btn-dark !py-2.5" onClick={open} disabled={busy || Number.isNaN(Number(float)) || Number(float) < 0}>{t("shift.openAction")}</button>
    </div>
  );
}
